<template>
  <van-popup v-model:show="showPopup" position="bottom" round :style="{
    background: '#221b24',
    zIndex: '1998',
    minWidth: '100%',
    minHeight: '100%',
  }">
    <div class="popup-container">
      <CustomHeader :text="$t('common.carteira')" :is-popup-close-back-icon="true" @close-popup="closePopup" />
      <div class="deposit-withdraw-page">
        <!-- Tabs -->
        <div class="tab-header">
          <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
            {{ $t('common.deposite') }}
          </div>
          <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
            {{ $t('common.sake') }}
          </div>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <depositView ref="depositRef" v-if="activeTab === 0" />
          <WithdrawView v-if="activeTab === 1" />
        </div>
      </div>
    </div>
  </van-popup>

  <!-- Button to open the popup -->
  <!-- <van-button type="primary" block @click="showPopup = true">
    {{ $t('common.openWallet') }}
  </van-button> -->
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, inject } from 'vue'
import depositView from '../deposit/depositView.vue'
import WithdrawView from '../withdraw/withdrawView.vue'
import CustomHeader from '@/themes/themeTwo/components/common/customHeader.vue'
import { useRoute, useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const showPopup = ref(false)
const activeTab = ref(0)
const routeValue = ref(route.query.value)
const depositRef = ref()
const emits = defineEmits(['handleClose', 'resetDepositData', 'reopenBackgroundRechargePopup'])
const openPopup = (val: any) => {
  activeTab.value = val
  showPopup.value = true
  depositRef.value?.resetData()
}
const closePopup = () => {
  showPopup.value = false
  if (routeValue.value) {
    router.replace({ path: '/sdbigdep', query: {} })
  } else if (userStore.takeFirstDeposit) {
    router.replace({ path: '/firstDeposit', query: {} })
  } else {
    router.replace({ path: '/home', query: {} })
  }
  emits('handleClose')
  userStore.setTakeFirstDeposit(false)
  if (userStore.pendingBackendRecharge?.id) {
    emits('reopenBackgroundRechargePopup')
  }
}

defineExpose({ openPopup, closePopup })
</script>

<style scoped>
.popup-container {
  padding: 70px 15px 100px;
  height: 100%;
  overflow-y: auto;
}

::-webkit-scrollbar {
  display: none;
}

.deposit-withdraw-page {
  background-color: #221b24;
  color: #fff;
}

.tab-header {
  display: flex;
  gap: 5px;
  border-radius: 10px;
  background-color: #221b24;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 15px 0;
  font-weight: bold;
  cursor: pointer;
  color: #7c5a86;
  background-color: #3b2a4b;
  border-radius: 12px;
  font-size: 15.84px;
}

.tab-item.active {
  background-color: #fd66b1;
  color: #fff;
}

.van-overlay {
  z-index: 1997 !important;
}
</style>
